<template>
  <div class="bill-records">
    <div
      class="selector-container section-container d-flex align-items-center"
       :class="{'dark':skinType}"
    >
      <SectionTitle title="账单记录"></SectionTitle>
      <el-form :inline="true" style="text-align: left" size="small">
        <el-form-item label="类型" :class="{'light-label':skinType}">
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起止日期" :class="{'light-label':skinType}" v-if="value===0">
          <el-date-picker
            v-model="selectDatePeriod"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="起止月份" :class="{'light-label':skinType}" v-else>
          <el-date-picker
            v-model="selectMonthPeriod"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            value-format="yyyy-MM"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chaxun(0)">查询</el-button>
          <el-button @click="chaxun(1)">导出</el-button>
        </el-form-item>
      </el-form>
      <el-button style="margin-left:auto;"
       type="primary" circle icon="iconfont  iconfanhui"
        v-on:click="$router.go(-1)"></el-button>
    </div>
    <!-- 表格 -->
    <el-table  size="small"
      id="zhangdan"
      ref="zhangDan"
            height="100%"
      :data="tableData"
      tooltip-effect="dark"
      highlight-current-row
      style="font-size: 0.8rem"
      :class="{'dark':skinType}"
    >
      <el-table-column type="index" width="50"> </el-table-column>
      <el-table-column prop="FirmName" label="用户名称"> </el-table-column>
      <el-table-column prop="usercode" label="用户编码"> </el-table-column>
      <el-table-column prop="Wattage" label="用量"> </el-table-column>
      <el-table-column prop="Total" label="费用"> </el-table-column>
      <el-table-column prop="OccurDate" label="当前时间"> </el-table-column>
    </el-table>
    <!-- 页数 -->
    <div
      v-if="pagetotal"
      style="
        display: flex;
        width: 100%;
        justify-content: flex-end;
        align-items: center;
        background-color:white;
      "
    >
        <el-pagination
          style="margin-left: auto"
          background
          layout="total, prev, pager, next"
          :total="pagetotal"
          :current-page.sync="pageNum"
        >
        </el-pagination>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import { getBillRecords } from '@/api/bill-records/billRecords';
import { exportExcel, formatDate } from '@/utils/utils';

export default {
  name: 'bill-records',
  components: {
    SectionTitle,
  },
  data() {
    return {
      // 日月账单选项
      options: [
        {
          value: 0,
          label: '用户日账单',
        },
        {
          value: 1,
          label: '用户月账单',
        },
      ],
      value: 0,
      selectDatePeriod: [
        formatDate(new Date(), 'yyyy-MM-01'),
        formatDate(new Date(), 'yyyy-MM-dd'),
      ],
      selectMonthPeriod: [
        formatDate(new Date(), 'yyyy-01'),
        formatDate(new Date(), 'yyyy-MM'),
      ],
      tableData: [],
      // 商户列表点击传入的商户id(测试的时候直接填入3)
      FirmID: this.$route.query.id,
      // 一共多少条数据
      pageNum: 1,
      // 页数（传入值页数乘以每页多少条才会自动生成多少页）
      pagetotal: 0,
      // 一页多少条数据
      pageSize: 10,
    };
  },
  created() {
    this.requestBillRecords();
  },
  computed: {
    firmId() {
      return this.$route.params.id;
    },
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    requestBillRecords() {
      const [start, end] = this.value
        ? this.selectMonthPeriod
        : this.selectDatePeriod;
      getBillRecords({
        FirmID: this.firmId,
        DateType: this.value ? 'Month' : 'Day',
        BeginDate: start,
        EndDate: end,
        IsExport: 0,
        Page: this.pageNum,
        Rows: this.pageSize,
      })
        .then((res) => {
          this.tableData = res.list || res;
          this.pagetotal = res.total || 0;
        })
        .catch(() => {
          this.tableData = [];
          this.pagetotal = 0;
        });
    },
    // 查询还是导出
    chaxun(type) {
      if (type === 0) {
        this.requestBillRecords();
        return;
      }
      exportExcel(this.$refs.zhangDan.$el);
    },
    // 页码
    pageNow1(pageNnm) {
      this.pageNum = pageNnm;
      this.requestBillRecords();
    },
  },
};
</script>
<style scoped>
.bill-records {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.riyue {
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}
.labelS {
  font-size: 0.8rem;
  width: 42%;
}
.operate {
  width: 9%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
}
.tableexport {
  margin-left: 6px;
}
</style>
